export * from './post-zeit-art-request.interface';
export * from './post-zeit-art-response.interface';
export * from './post-zeit-art.shapes';
